import { RenderButtonProps, StatusErrorMap } from "../types/types";
import "../../styles/HotelRenderButton.css";
import { useGame } from "../../GameContext";
import MESSAGES from "./message";
import {
  evaluateAnswers,
  parseCommand,
  lightCorrectRooms,
} from "../games/orbitalLogic";
import { checkAdressAnswer } from "../games/adressLogic";
import OrbitalPanel from "./panels/OrbitalPanel";
import AdressPanel from "./panels/AdressPanel";

const RenderButton: React.FC<RenderButtonProps> = ({
  gameStyle,
  answers,
  setAnswers,
  activeCharacters,
  correctPositions,
  maxRounds,
  statusError,
  selectedRoom,
  currentTask,
  setCurrentTaskIndex,
  setSelectedErrorRoom,
  setSelectedRoom,
  setStatusError,
  setUIcolumns,
}) => {
  const {
    setMessage,
    attempts,
    setIsTimerRunning,
    roundState,
    setRoundState,
    round,
    setRound,
    isGameStarted,
    setGameStarted,
    setTime,
    setAttempts,
  } = useGame();

  // функция для перезапуска игры
  const handleRestart = () => {
    setRound(1);
    setTime(0);
    setAttempts(0);
  };

  // изменение ответа пользователя
  const handleChange = (id: number, value: string) => {
    const parsed = parseCommand(value.toLowerCase());

    setAnswers((prev) =>
      prev.map((item) =>
        item.idCharecter === id
          ? {
              ...item,
              input: value,
              position: parsed,
            }
          : item,
      ),
    );
  };

  // функция для проверки ответа в режиме adress
  const handleAdressCheck = () => {
    setAttempts((prev) => prev + 1);
    const status: StatusErrorMap = {};
    const visibleTasks = correctPositions.slice(0, currentTask);
    const task = visibleTasks[visibleTasks.length - 1];

    if (!task) return;

    const id = task.idCharecter;

    if (!selectedRoom) {
      status[id] = "noSelect";
      setStatusError((prev) => ({
        ...prev,
        ...status,
      }));
      setMessage(MESSAGES.selectRoom);
      return;
    }
    const isCorrect = checkAdressAnswer(selectedRoom, task);

    const selectedKey = selectedRoom.column + selectedRoom.roomId;

    if (isCorrect) {
      status[id] = "true";

      setMessage(MESSAGES.correctCharacter);

      setUIcolumns((prev) =>
        prev.map((col) => ({
          ...col,
          rooms: col.rooms.map((room) => {
            const key = room.column + room.id;

            return {
              ...room,
              isOpen: room.isOpen || key === selectedKey,
            };
          }),
        })),
      );

      const isLastTask = currentTask >= correctPositions.length;

      if (isLastTask) {
        if (round < maxRounds) {
          setRoundState("success");
          setMessage(MESSAGES.roundSuccess);
        } else {
          setRoundState("finished");
          setMessage(MESSAGES.gameFinished(attempts + 1));
        }

        setIsTimerRunning(false);
      } else {
        setCurrentTaskIndex((prev) => prev + 1);
      }
    } else {
      status[id] = "false";
      setSelectedErrorRoom(selectedRoom);
      setMessage(MESSAGES.wrongChoice);
    }

    setStatusError((prev) => ({
      ...prev,
      ...status,
    }));

    setSelectedRoom(null);
  };

  //проверка всех ответов в режиме orbital
  const handleOrbitalCheck = () => {
    const result = evaluateAnswers(answers, correctPositions);
    setAttempts((prev) => prev + 1);
    setStatusError(result.status);

    lightCorrectRooms(result.status, setUIcolumns);

    if (result.hasEmpty) {
      setMessage(MESSAGES.emptyFields);
      return;
    }

    if (result.hasErrors) {
      setMessage(MESSAGES.hasErrors);
      return;
    }

    if (round < maxRounds) {
      setRoundState("success");
      setMessage(MESSAGES.roundSuccess);
      setIsTimerRunning(false);
    } else {
      setRoundState("finished");
      setMessage(MESSAGES.gameFinished(attempts + 1));

      setIsTimerRunning(false);
    }
  };
  // функция для получения изображения для колл-статуса персонажа
  const getCallImg = (id: number) => {
    switch (statusError[id]) {
      case "true":
        return "/img/stevehotel/call/true.svg";
      case "false":
        return "/img/stevehotel/call/false.svg";
      default:
        return "/img/stevehotel/call/null.svg";
    }
  };

  return (
    <div className="hotel-control">
      {gameStyle === "orbital" ? (
        <OrbitalPanel
          activeCharacters={activeCharacters}
          answers={answers}
          handleChange={handleChange}
          getCallImg={getCallImg}
        />
      ) : (
        <AdressPanel
          correctPositions={correctPositions}
          getCallImg={getCallImg}
          currentTask={currentTask}
          statusError={statusError}
        />
      )}
      {!isGameStarted ? (
        <button
          title="Начать игру"
          className="hotel-buttonCheck"
          onClick={() => {
            setGameStarted(true);
            setIsTimerRunning(true);
          }}
        >
          Начать игру
          <img alt="" className="hotel-logoRun" src="/img/button/run-fix.svg" />
        </button>
      ) : (
        <>
          {roundState === "finished" && (
            <button
              title="Играть ещё"
              onClick={handleRestart}
              className="hotel-buttonCheck"
            >
              Играть ещё
                <img
                  alt=""
                  className="hotel-logoRun"
                  src="/img/button/run-fix.svg"
                />
            </button>
          )}
          {roundState === "playing" &&
            (gameStyle === "orbital" ? (
              <button
                className="hotel-buttonCheck"
                onClick={handleOrbitalCheck}
              >
                Проверить
              </button>
            ) : (
              <button className="hotel-buttonCheck" onClick={handleAdressCheck}>
                Проверить
              </button>
            ))}

          {roundState === "success" && (
            <button
              onClick={() => {
                setRound((r) => r + 1);
              }}
              className="hotel-buttonCheck"
            >
              Далее
                <img alt="" className="hotel-logoRun" src="/img/button/run-fix.svg" />
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default RenderButton;
